import React from "react"
import { InputText } from "../common/forms"

const AddressFields = ({
  handler,
  errors,
  values
}) => {
  return (
    <React.Fragment>
      <InputText
        className={errors.billingStreet && "error"}
        type="text"
        name="billingStreet"
        label="Street"
        value={values.billingStreet}
        handler={handler}
        required={true}
        placeholder="123 Main St."
      />
      <InputText
        className={errors.billingCity && "error"}
        type="text"
        name="billingCity"
        label="City"
        value={values.billingCity}
        handler={handler}
        required={true}
        placeholder="Albany"
      />
      <InputText
        className={errors.billingState && "error"}
        type="text"
        name="billingState"
        label="State / Region"
        value={values.billingState}
        handler={handler}
        required={true}
        placeholder="NY"
      />
      <InputText
        className={errors.billingZipCode && "error"}
        type="text"
        name="billingZipCode"
        label="Zip / Postal Code"
        value={values.billingZipCode}
        handler={handler}
        required={true}
        placeholder="12084"
      />
    </React.Fragment>
  )
}

export default AddressFields
